"use client";

import { ImgHTMLAttributes, useLayoutEffect, useRef, useState } from "react";
import { IMAGE_POSTFIX_MOBILECARD, IMAGE_POSTFIX_WEBCARD, IMAGE_POSTFIX_WEBFULL } from "commonModule/globalConstant";
import { FALLBACK_LOGO_IMAGE } from "constant";
const ImageWithFallback = ({
  src = "",
  postfix = IMAGE_POSTFIX_WEBCARD,
  fallbackSrc = FALLBACK_LOGO_IMAGE,
  ...rest
}: {
  src?: string | undefined;
  postfix?: typeof IMAGE_POSTFIX_WEBCARD | typeof IMAGE_POSTFIX_MOBILECARD | typeof IMAGE_POSTFIX_WEBFULL | null;
  fallbackSrc?: string;
} & ImgHTMLAttributes<HTMLImageElement>) => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const handleError = () => {
    if (imgRef.current) {
      // Update src to fallbackSrc
      imgRef.current.src = imgRef.current.src.includes(`${src}_${postfix || ""}`) ? src : fallbackSrc;
    }
  };
  const [isLoaded, setIsLoaded] = useState(false);
  useLayoutEffect(() => {
    setIsLoaded(true);
  }, []);
  if (!isLoaded) return null;
  return <img ref={imgRef} src={src && postfix ? `${src}_${postfix}` : src} alt='' onError={handleError} {...rest} data-sentry-component="ImageWithFallback" data-sentry-source-file="ImageWithFallback.tsx" />;
};
export default ImageWithFallback;